import { Edit, RefreshButton, SaveButton, useForm } from '@refinedev/antd';
import { type HttpError, useGo } from '@refinedev/core';
import { message } from 'antd';
import { useEffect, useState } from 'react';

import ProtectedDeleteButton from '@/components/protected/ProtectedDeleteButton';
import { FAIL_REPORT_STATUS, FailReport } from '@/model/FailReport/FailReport';
import { FailReportItem } from '@/model/FailReport/FailReportItem';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';
import { RESOURCES } from '@/Resources';

import FailReportForm from './FailReportForm/FailReportForm';

const FailReportEdit = () => {
  const go = useGo();
  const { failReportRepository } = useRepositoriesContext();
  const [failReportItems, setFailReportItems] = useState<FailReportItem[]>([]);
  // Refine usa el tercer genérico para tipar los valores del Form de Ant Design.
  const { formProps, saveButtonProps, query } = useForm<FailReport, HttpError, FailReport>({
    successNotification: {
      message: 'Informe de falla actualizado correctamente',
      type: 'success',
    },
    onMutationSuccess(failReportResponse) {
      if (failReportResponse.data.id) {
        void failReportRepository
          .saveFailReportItems(failReportItems, failReportResponse.data.id)
          .catch(error => {
            message.error('Ocurrió un error al guardar los items del informe de falla.');
            console.error('Error saving fail report items:', error);
          });
      }
    },
  });

  useEffect(() => {
    // Si estamos en modo edición y el estado no lo permite, redirigimos a show
    if (
      formProps.initialValues?.id &&
      ![FAIL_REPORT_STATUS.INSTANCE_1, FAIL_REPORT_STATUS.INSTANCE_2].includes(
        formProps.initialValues.status,
      )
    ) {
      go({
        to: { resource: RESOURCES.FAIL_REPORTS, action: 'show', id: formProps.initialValues.id },
      });
    }
  }, [formProps.initialValues, go, setFailReportItems]);

  return (
    <Edit
      isLoading={query?.isLoading || query?.isFetching}
      footerButtons={({ deleteButtonProps }) => (
        <>
          <ProtectedDeleteButton {...deleteButtonProps} />
          <SaveButton {...saveButtonProps} />
        </>
      )}
      headerButtons={({ refreshButtonProps }) => <RefreshButton {...refreshButtonProps} />}>
      {query?.data && (
        <FailReportForm
          formProps={formProps}
          failReportItems={failReportItems}
          setFailReportItems={setFailReportItems}
          edit
        />
      )}
    </Edit>
  );
};

export default FailReportEdit;
